@if (shouldShowControl()) {
  <span class="w-100 separator" [ngStyle]="{'height': getSize()}"></span>
}
